module.exports = __webpack_public_path__ + "bg.png?866d039a0fc908eab867775f469be6d3";